import { render, staticRenderFns } from "./SalesContract.vue?vue&type=template&id=63699ece&"
import script from "./SalesContract.vue?vue&type=script&lang=js&"
export * from "./SalesContract.vue?vue&type=script&lang=js&"
import style0 from "./SalesContract.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SalesContract.vue"
export default component.exports